import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { ChequePaymentTimeReportViewModel, row, TransactionTypeEnumProvider } from "./chequePaymentTimeReport-viewModel"

export class ChequePaymentTimeReportView extends View<ChequePaymentTimeReportViewModel>{
    GetViewUniqueId(): string {
        return "V-B7C3714F-5C97-47C5-B0AC-60070BB3C756"
    }
    loadHtml(): string {
        let element = require('./chequePaymentTimeReport.html').default;
        let style = require('./chequePaymentTimeReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set transactionTypeEnumProvider(v: TransactionTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTypeEnumProvider;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    refresh(){
        this.dataContext.refresh();
    }
}
